"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_i18next_1 = require("react-i18next");
var translator_1 = __importDefault(require("../translator"));
var useTranslate = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var translator = new translator_1.default(t);
    var translateMethod = function (key, allowEmptyTranslation, interpolationValues) {
        if (allowEmptyTranslation === void 0) { allowEmptyTranslation = false; }
        return translator.translate(key, allowEmptyTranslation, interpolationValues);
    };
    return translateMethod;
};
exports.default = useTranslate;
